import Input from "component/ui/Input";
import React, { useState } from "react";
import {
  FacebookShareButton,
  WhatsappShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  TelegramShareButton,
  RedditShareButton,
  EmailShareButton,
  PinterestShareButton,
  FacebookIcon,
  WhatsappIcon,
  LinkedinIcon,
  TwitterIcon,
  TelegramIcon,
  RedditIcon,
  EmailIcon,
  PinterestIcon,
} from "react-share";

const ShareModal = ({ onClose, shareUrl, setShareUrl }) => {
  const [copied, setCopied] = useState(false);

  const handleCopyLink = () => {
    navigator.clipboard.writeText(shareUrl);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const socialPlatforms = [
    { Button: FacebookShareButton, Icon: FacebookIcon, name: "Facebook" },
    { Button: TwitterShareButton, Icon: TwitterIcon, name: "Twitter" },
    { Button: LinkedinShareButton, Icon: LinkedinIcon, name: "LinkedIn" },
    { Button: WhatsappShareButton, Icon: WhatsappIcon, name: "WhatsApp" },
    { Button: TelegramShareButton, Icon: TelegramIcon, name: "Telegram" },
    { Button: RedditShareButton, Icon: RedditIcon, name: "Reddit" },
    {
      Button: PinterestShareButton,
      Icon: PinterestIcon,
      name: "Pinterest",
      props: { media: shareUrl },
    },
    { Button: EmailShareButton, Icon: EmailIcon, name: "Email" },
  ];

  return (
    <div
      className="md:p-5 p-3 bg-white rounded-lg relative w-96"
      onClick={(e) => e.stopPropagation()}
    >
      {/* Close Button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 w-8 h-8 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center text-gray-600 hover:text-gray-900 transition-colors"
        aria-label="Close modal"
      >
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M6 18L18 6M6 6l12 12"
          />
        </svg>
      </button>

      {/* Header */}
      <div className="text-center mb-3">
        <div className="w-10 h-10 mx-auto mb-4 rounded-lg bg-brand-gradient flex items-center justify-center shadow-lg">
          <svg
            className="w-6 h-6 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
            />
          </svg>
        </div>
        <h2 className="md:text-2xl text-lg font-medium text-black">
          Share this link
        </h2>
        <p className="text-gray-500">Choose your preferred platform</p>
      </div>

      {/* Input Section */}
      <div className="mb-6">
        <div className="relative">
          <Input
            isForm
            type="text"
            value={shareUrl}
            onChange={(e) => setShareUrl(e.target.value)}
            placeholder="Paste your link here"
            className="placeholder:text-black text-black"
          />

          <button
            onClick={handleCopyLink}
            className={`absolute right-2 top-1/2 -translate-y-1/2 p-2 rounded-lg transition-colors ${
              copied
                ? "bg-green-500 text-white"
                : "bg-gray-100 hover:bg-brand-gradient text-gray-600 hover:text-white"
            }`}
            aria-label="Copy link"
          >
            {copied ? (
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2.5}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            ) : (
              <svg
                className="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z"
                />
              </svg>
            )}
          </button>
        </div>
        {copied && (
          <p className="text-sm text-green-600 font-medium text-center mt-2">
            Link copied to clipboard!
          </p>
        )}
      </div>

      {/* Divider */}
      <div className="relative my-6">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-200"></div>
        </div>
        <div className="relative flex justify-center text-sm">
          <span className="px-4 bg-white text-gray-500 uppercase tracking-wide font-medium">
            or share via
          </span>
        </div>
      </div>

      {/* Social Buttons */}
      <div className="grid grid-cols-4 gap-4">
        {socialPlatforms.map(({ Button, Icon, name, props = {} }) => (
          <Button key={name} url={shareUrl} className="w-full" {...props}>
            <div
              className="md:w-20 md:h-20 w-16 h-16 flex flex-col items-center justify-center gap-2 md:rounded-xl rounded-lg bg-gray-100
          hover:bg-gray-100 hover:shadow-md transition-all cursor-pointer group"
            >
              <div className="transform group-hover:scale-110 transition-transform">
                <Icon size={26} round />
              </div>

              <span className="md:text-xs text-[10px] font-medium text-gray-700 text-center">
                {name}
              </span>
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default ShareModal;
